module.exports = __webpack_public_path__ + "img/tk.f7330453.png";